<!-- 全局登录页面 -->
<template>
    <div class="login d-flex" style="justify-content: center">
        <div class="d-flex" style="align-items: center;">
            <div class="logCard">
                <!-- logo -->
                <div class="logoHome" @click="logoGoHome">
                    <img src="../../assets/img/logo.gif" width="300" v-show="logStatus">
                    <!--显示一行小字 威高骨科-->
<!--                  <div style="font-size: 20px;color: #288cf1;text-align: right;font-weight: bold;">威高骨科</div>-->
                </div>
                <!-- 密码登录表单 -->
               <el-form ref="ruleForm" :rules="rules" :model="form" v-show="logStatus && !logType">
                    <el-form-item prop="phone">
                        <el-input v-model="form.phone" placeholder="请输入手机号">
                        </el-input>
                    </el-form-item>
                    <el-form-item prop="password">
                        <el-input v-model="form.password"  type="password" placeholder="请输入密码">
                        </el-input>
						<span style="position: absolute;right: 0;cursor: pointer;" @click="forgetPassOpen">忘记密码？</span>
                    </el-form-item>
					<el-form-item prop="verifycode">
						<div style="display:flex">
						<el-input v-model="form.verifycode" placeholder="请输入验证码"/>
						<span @click="refreshCode">
							<s-identify :identifyCode="identifyCode"></s-identify>
						</span>
						</div>
					</el-form-item>
                    <el-form-item>
                        <el-button type="primary"  class="w-100" @click="login" :loading="loading">
                            {{loading? '登录中...' : '立即登录'}}
                        </el-button>
                    </el-form-item>
                </el-form>
				<!-- 手机验证码登录-->
				<el-form ref="phoneLogForm" :rules="phoneLogRules" :model="phoneLogForm" v-show="logType && logStatus">
				    <el-form-item prop="phone">
				        <el-input v-model="phoneLogForm.phone"  placeholder="请输入手机号">
				        </el-input>
				    </el-form-item>
					<el-form-item prop="smscode" class="code">
					    <el-input v-model="phoneLogForm.smscode" placeholder="验证码" style="width: 120px;">
					    </el-input>
					    <el-button type="primary" :disabled='isDisabled' @click="sendCode('logSend')"
					               style="position: relative;left: 5px;" plain>{{buttonText}}
					    </el-button>
					</el-form-item>
				    <el-form-item>
				        <el-button type="primary"  class="w-100" @click="login" :loading="loading">
				            {{loading? '登录中...' : '立即登录'}}
				        </el-button>
				    </el-form-item>
				</el-form>
				<p class="text-center text-primary noneNumber" @click="logType = !logType" v-show="logStatus">
					{{logType ? '使用密码登录' : '短信验证码登录'}}
				</p>
                <p class="text-center text-white noneNumber" @click="goReg()" v-show="logStatus">还没有账号？点击注册</p>
                <!-- 注册表单 -->
				<div class="register-wrapper" v-show="!logStatus">
                    <div id="register">
                        <img src="../../assets/img/logo.gif" width="200" class="logoHome" @click="logoGoHome">
                        <el-form :model="ruleForm2" status-icon :rules="rules2" ref="ruleForm2" label-width="0"
                                 class="demo-ruleForm">
                            <el-form-item prop="phone">
                                <el-input v-model="ruleForm2.phone" auto-complete="off" placeholder="请输入手机号"></el-input>
                            </el-form-item>
                            <el-form-item prop="smscode" class="code">
                                <el-input v-model="ruleForm2.smscode" placeholder="验证码" style="width: 120px;">
                                </el-input>
                                <el-button type="primary" :disabled='isDisabled' @click="sendCode('register')"
                                           style="position: relative;left: 5px;">{{buttonText}}
                                </el-button>
                            </el-form-item>
                            <el-form-item prop="pass">
                                <el-input type="password" v-model="ruleForm2.pass" auto-complete="off"
                                          placeholder="输入密码"></el-input>
                            </el-form-item>
                            <el-form-item prop="checkPass">
                                <el-input type="password" v-model="ruleForm2.checkPass" auto-complete="off"
                                          placeholder="确认密码"></el-input>
                            </el-form-item>
                            <el-form-item>
                                <el-button type="primary" @click="submitForm('ruleForm2')" style="width:100%;"
								:disabled="ruleForm2.smscode.length!== 4">注册
                                </el-button>
                                <p class="gologin" @click="gotoLogin">已有账号？立即登录</p>
                            </el-form-item>
                        </el-form>
                    </div>
                </div>
				<!-- 找回密码弹窗 -->
				<el-dialog v-model="forgetPassword" title="找回密码" width="300px">
					<el-form ref="forgetPassForm" :rules="forgetPassFormRules" :model="forgetPassForm">
						<el-form-item prop="phone">
							<el-input v-model="forgetPassForm.phone" placeholder="请输入手机号">
							</el-input>
						</el-form-item>
						<el-form-item prop="smscode" class="code">
							<el-input v-model="forgetPassForm.smscode" placeholder="验证码" style="width: 120px;">
							</el-input>
							<el-button type="primary" :disabled='isDisabled' @click="sendCode('forgetPassWord')"
									   style="position: relative;left: 5px;" plain>{{buttonText}}
							</el-button>
						</el-form-item>
						<el-form-item prop="newPassword">
							<el-input v-model="forgetPassForm.newPassword" type="password" placeholder="请输入新密码">
							</el-input>
						</el-form-item>
						<el-form-item>
							<el-button type="primary"  class="w-100" @click="forgetPass" :loading="forgetPassLoading">
								{{forgetPassLoading? '修改中...' : '修改密码'}}
							</el-button>
						</el-form-item>
					</el-form>
				</el-dialog>
            </div>
        </div>
		<!-- 底部版权信息 -->
		<div class="text-white" style="position: absolute;bottom: 10px;">
			2022 ©山东恒达知识产权股份有限公司
		</div>
    </div>
</template>

<script>
    import {
        mapGetters
    } from 'vuex'
	import { ElNotification } from 'element-plus'
	// 图形验证码
	import SIdentify from '@/components/identify/identify.vue'
    export default {
		components: {
			SIdentify
		},
		mounted() {
			if(this.$route.query.isReg == 'true'){
				this.goReg()
			}
			// 验证码初始化
			this.identifyCode = ''
			this.makeCode(this.identifyCodes, 4)
		},
        data() {
            // <!--验证手机号是否合法-->
            let checkTel = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请输入手机号码'))
                } else if (!this.checkMobile(value)) {
                    callback(new Error('手机号码不合法'))
                } else {
                    callback()
                }
            }
            //  <!--验证码是否为空-->
            let checkSmscode = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请输入手机验证码'))
                } else {
                    callback()
                }
            }
            // <!--验证密码-->
            let validatePass = (rule, value, callback) => {
                if (value === "") {
                    callback(new Error("请输入密码"))
                } else {
                    if (this.ruleForm2.checkPass !== "") {
                        this.$refs.ruleForm2.validateField("checkPass");
                    }
                    callback()
                }
            }
            // <!--二次验证密码-->
            let validatePass2 = (rule, value, callback) => {
                if (value === "") {
                    callback(new Error("请再次输入密码"));
                } else if (value !== this.ruleForm2.pass) {
                    callback(new Error("两次输入密码不一致!"));
                } else {
                    callback();
                }
            };
			// 图形验证码验证规则
			const validateVerifycode = (rule, value, callback) => {
			  const newVal = value.toLowerCase()
			  const identifyStr = this.identifyCode.toLowerCase()
			  if (newVal === '') {
				callback(new Error('请输入验证码'))
			  } else if (newVal !== identifyStr) {
				callback(new Error('验证码不正确!'))
			  } else {
				callback()
			  }
			}
            return {
                loading: false,
				forgetPassLoading:false,
                logStatus: true,
				identifyCodes: '3456789ABCDEFGHGKMNPQRSTUVWXY',
				identifyCode: '',
				// 登录方式
				logType:false,
				// 忘记密码
				forgetPassword:false,
				// 手机号密码登录
                form: {
                    phone: "",
                    password: "",
					verifycode:""
                },
				// 短信验证码登录
				phoneLogForm: {
				    phone: "",
					smscode:""
				},
				// 注册表单
                ruleForm2: {
                    pass: "",
                    checkPass: "",
                    phone: "",
                    smscode: ""
                },
				// 忘记密码
				forgetPassForm:{
					phone:"",
					smscode:"",
					newPassword:""
				},
				// 登录表单验证
				rules: {
				    phone: [{
				        validator: checkTel,
				        trigger: 'blur'
				    }],
				    password: [{
				        required: true,
				        message: "请输入密码",
				        trigger: 'blur'
				    }],
					verifycode: [
					  { required: true, trigger: 'blur', validator: validateVerifycode }
					]
				},
				// 短信验证码登录验证
				phoneLogRules: {
				    phone: [{
				        validator: checkTel,
				        trigger: 'blur'
				    }],
					smscode: [{
					    validator: checkSmscode,
					    trigger: 'change'
					}],
				},
				// 注册表单验证
                rules2: {
                    pass: [{
                        validator: validatePass,
                        trigger: 'change'
                    }],
                    checkPass: [{
                        validator: validatePass2,
                        trigger: 'change'
                    }],
                    phone: [{
                        validator: checkTel,
                        trigger: 'change'
                    }],
                    smscode: [{
                        validator: checkSmscode,
                        trigger: 'change'
                    }],
                },
				// 找回密码表单验证
				forgetPassFormRules: {
				    phone: [{
				        validator: checkTel,
				        trigger: 'blur'
				    }],
				    newPassword: [{
				        required: true,
				        message: "请输入新密码",
				        trigger: 'blur'
				    }],
					smscode: [{
					    validator: checkSmscode,
					    trigger: 'change'
					}],
				},
                buttonText: '发送',
                isDisabled: false, // 是否禁止点击发送验证码按钮
                flag: true
            }
        },
        computed: {
            ...mapGetters([
                'adminIndex'
            ])
        },
        methods: {
			goLog(formName){
				this.$refs[formName].validate((e) => {
				    if (!e) return;
				    // 提交表单
				    this.loading = true

				    this.axios.post('/api/platform/login', {
				        phone: this.form.phone,
				        password: this.form.password,
						type:'phonePassword'
				    }).then(res => {
                        //校验成功
                        if (res.data.success == false) {
							this.refreshCode()
                            // 成功提示
                            ElNotification({
                                title: '登录',
                                message: res.data.msg,
                                type: 'error', //警告:warning,信息:info,失败:error,成功success
                            })
                            this.loading = false
                        }else{
                            // 存储到vuex
                            let data = res.data.data
                            // 存储到本地存储
                            this.$store.commit('login', data)
                            // 成功提示
                            ElNotification({
                                title: '登录',
                                message: res.data.msg,
                                type: 'success', //警告:warning,信息:info,失败:error,成功success
                            })
                            this.loading = false
                            // 跳转首页
                            this.$router.go(-1)
                        }
				    }).catch(err => {
				        this.loading = false
				    })
				})
			},
            login(){
				if(this.logType){
					if(this.phoneLogForm.phone === '') return
					// 将此处替换为接口替换为短信验证码登录验证
					this.axios.post('/api/platform/register/checkCode', {
					    phone: this.phoneLogForm.phone,
					    code:this.phoneLogForm.smscode,
						type:"logSend"
					}).then(res => {
						//校验成功
						if (res.data.success == true) {
							//验证码登录
							this.loading = true
							this.axios.post('/api/platform/login', {
								phone: this.phoneLogForm.phone,
								type:"logSend"
							}).then(res => {
								// 存储到vuex
								let data = res.data.data
								// 存储到本地存储
								this.$store.commit('login', data)
								// 成功提示
								ElNotification({
									title: '登录',
									message: res.data.msg,
									type: 'success', //警告:warning,信息:info,失败:error,成功success
								})
								this.loading = false
								// 跳转首页
								this.$router.go(-1)
							}).catch(err => {
								this.loading = false
							})
						} else {
							ElNotification({
								title: '验证码',
								message: res.data.msg,
								type: 'error', //警告:warning,信息:info,失败:error,成功success
							})
						}
					}).catch(err=>{

					})
				}
				if(!this.logType){
					this.goLog('ruleForm')
				}
            },

            // 注册
            goReg() {
                this.logStatus = false
				this.$refs['ruleForm2'].resetFields()
            },
            // 通过logo前往首页
            logoGoHome() {
                this.$router.push('/')
            },
            // 发送验证码
            sendCode(sendType) {
                // let phone = sendType == 'logSend' ? this.form.phone : this.ruleForm2.phone
				let phone = ''
				switch (sendType){
					case 'logSend':
					phone = this.phoneLogForm.phone
					break;
					case 'register':
					phone = this.ruleForm2.phone
					break;
					case 'forgetPassWord':
					phone = this.forgetPassForm.phone
					break;
				}
                if (this.checkMobile(phone)) {
                    //发送验证码请求等待响应
                    this.axios.post('/api/platform/sendCode', {
                        phone: phone,
						type: sendType
                    }).then(res => {
                        //正常发送短信
                        if (res.data.success == true) {
                            let time = 60
                            this.buttonText = '已发送'
                            this.isDisabled = true
                            if (this.flag) {
                                this.flag = false;
                                let timer = setInterval(() => {
                                    time--;
                                    this.buttonText = time + ' 秒'
                                    if (time === 0) {
                                        clearInterval(timer);
                                        this.buttonText = '重新获取'
                                        this.isDisabled = false
                                        this.flag = true;
                                    }
                                }, 1000)
                            }
                        } else {
                            //异常提醒
                            ElNotification({
                                title: '验证码',
                                message: res.data.msg,
                                type: 'error', //警告:warning,信息:info,失败:error,成功success
                            })
                        }
                    }).catch(err => {

                    })

                }
            },
			// 打开忘记密码窗口
			forgetPassOpen(){
				let vm = this
				vm.forgetPassword = true
			},
			// 修改密码
			forgetPass(){
				this.$refs.forgetPassForm.validate((e) => {
				    if (!e) return;
				    // 提交表单
				    this.forgetPassLoading = true
					//验证码校验
					this.axios.post('/api/platform/register/checkCode', {
						phone: this.forgetPassForm.phone,
						code:this.forgetPassForm.smscode,
						type:'forgetPassWord'
					}).then(res => {
						//校验成功
						if (res.data.success == true) {
							this.loading = true
							this.axios.post('/api/platform/login', {
								phone: this.forgetPassForm.phone,
								password: this.forgetPassForm.newPassword,
								type:"forgetPassWord"
							}).then(res => {
								// 存储到vuex
								let data = res.data.data
								// 存储到本地存储
								this.$store.commit('login', data)
								// 成功提示
								ElNotification({
									title: '找回密码',
									message: res.data.msg,
									type: 'success', //警告:warning,信息:info,失败:error,成功success
								})
								this.loading = false
								// 跳转首页
								this.$router.go(-1)
							}).catch(err => {
								this.loading = false
							})
						} else {
							ElNotification({
								title: '找回密码',
								message: res.data.msg,
								type: 'error', //警告:warning,信息:info,失败:error,成功success
							})
						}
				})
			})
			},
            //提交注册
            submitForm(formName) {
                this.$refs[formName].validate(valid => {
                    if (valid) {
                        //验证码校验
                        this.axios.post('/api/platform/register/checkCode', {
                            phone: this.ruleForm2.phone,
                            code:this.ruleForm2.smscode,
							type:'register'
                        }).then(res => {
                            //校验成功
                            if (res.data.success == true) {
                                //提交注册
                                this.axios.post('/api/platform/register', {
                                    phone: this.ruleForm2.phone,
                                    password:this.ruleForm2.pass
                                }).then(res => {
                                    //注册成功
                                    if (res.data.success == true) {
                                        ElNotification({
                                            title: '注册',
                                            message: res.data.msg,
                                            type: 'success', //警告:warning,信息:info,失败:error,成功success
                                        })
                                        //跳转登录页
                                        this.logStatus = true
                                    } else {
                                        ElNotification({
                                            title: '注册',
                                            message: res.data.msg,
                                            type: 'error', //警告:warning,信息:info,失败:error,成功success
                                        })
                                        this.logStatus = true
                                    }
                                }).catch(err => {

                                })
                            } else {
                                ElNotification({
                                    title: '验证码',
                                    message: res.data.msg,
                                    type: 'error', //警告:warning,信息:info,失败:error,成功success
                                })
                            }
                        }).catch(err => {

                        })
                    } else {
                        this.$message("注册校验异常")
                        return false;
                    }
                })
            },
            // 切换登录
            gotoLogin() {
                this.logStatus = true
                this.$refs['ruleForm'].resetFields()
            },
            // 验证手机号
            checkMobile(str) {
                let re = /^1\d{10}$/
                if (re.test(str)) {
                    return true;
                } else {
                    return false;
                }
            },
			 // 生成随机数
			randomNum(min, max) {
			  return Math.floor(Math.random() * (max - min) + min)
			},
			// 切换验证码
			refreshCode() {
			  this.identifyCode = ''
			  this.makeCode(this.identifyCodes, 4)
			},
			// 生成四位随机验证码
			makeCode(o, l) {
			  for (let i = 0; i < l; i++) {
				this.identifyCode += this.identifyCodes[
				  this.randomNum(0, this.identifyCodes.length)
				]
			  }
			}
        },
    }
</script>

<style scoped>
    .login {
        width: 100%;
        height: 100vh;
		background-color: #F0F0F0;
        background: url(../../assets/img/login_bg.webp),url(../../assets/img/login_bg.jpg) no-repeat;
        background-size: cover;
        -webkit-background-size: cover;
        -o-background-size: cover;
        background-position: center 0;
    }

    /* card-body */
    .logCard {
        width: 300px;
        margin-bottom: 200px;
    }

    #register {
        max-width: 340px;
        margin: 60px auto;
        background: #fff;
        padding: 20px 40px;
        border-radius: 10px;
        position: relative;
        z-index: 9;
    }

    .title {
        font-size: 26px;
        line-height: 50px;
        font-weight: bold;
        margin: 10px;
        text-align: center;
    }

    .el-form-item {
        text-align: center;
    }

    .gologin {
        margin-top: 10px;
        font-size: 14px;
        line-height: 22px;
        color: #1ab2ff;
        cursor: pointer;
        text-align: left;
        text-indent: 8px;
        width: 160px;
    }

    .gologin:hover {
        color: #2c2fd6;
    }

    .noneNumber:hover {
        cursor: pointer;
    }

    /* 	.code >>> .el-form-item__content {
      display: flex;
      align-items: center;
      justify-content: space-between;
    } */
    /* 	.code button {
      margin-left: 20px;
      width: 140px;
      text-align: center;
    } */
    .el-button--primary:focus {
        background: #409EFF;
        border-color: #409EFF;
        color: #fff;
    }
	.logoHome{
		margin-bottom:20px;
	}
    .logoHome:hover {
        cursor: pointer;
    }
</style>
